import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

//登录接口
export function login(data) {
    return http.request({
        url: common.url + '/papi/student/login',
        method: 'get',
		isToken:false,
        params: data
    })
}

//注册接口
export function register(data) {
    return http.request({
        url: common.url + '/papi/student/register',
        method: 'get',
        params: data
    })
}


//注册接口
export function updatePassword(data) {
    return http.request({
        url: common.url + '/papi/student/updatePassword',
        method: 'get',
        params: data
    })
}

// 暴露出我们的接口请求,export导出
export function queryLoginState(data) {
    return http.request({
        url: common.url + '/papi/student/queryLoginState',
        method: 'get',
        params: data
    })
}